import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  checkInCheckOutList: [],
  bookingInfo: null,
  pinpadDevicesList: [],
  chargeLessDetail: {
    booking_id: 0,
    final_capture_amount: 0,
    description: "",
    discount: 0,
    night: 0,
    charge_less: 0,
  }
};
const bookingSlice = createSlice({
  name: "booking",
  initialState: initialState,
  reducers: {
    checkInCheckOutListSuccess: (state, action) => {
      state.checkInCheckOutList = action.payload;
    },
    checkInCheckOutListFailed: (state, action) => {
      state.checkInCheckOutList = [];
    },
    bookingInfoSuccess: (state, action) => {
      state.bookingInfo = action.payload;
    },
    bookingInfoFailed: (state, action) => {
      state.bookingInfo = null;
    },
    pinpadDevicesListSuccess:  (state, action) => {
      state.pinpadDevicesList = action.payload;
    },
    pinpadDevicesListFailed:  (state, action) => {
      state.pinpadDevicesList = [];
    },
    chargeLessDetailSuccess: (state, action) => {
      state.chargeLessDetail = action.payload
    },
    chargeLessDetailFailed: (state, action) => {
      state.chargeLessDetail = {
        booking_id: 0,
        final_capture_amount: 0,
        description: "",
        discount: 0,
        night: 0,
        charge_less: 0,
      }
    },
  },
});

export const {
  checkInCheckOutListSuccess,
  checkInCheckOutListFailed,
  bookingInfoSuccess,
  bookingInfoFailed,
  pinpadDevicesListSuccess,
  pinpadDevicesListFailed,
  chargeLessDetailSuccess,
  chargeLessDetailFailed
} = bookingSlice.actions;
export default bookingSlice.reducer;
